import React, { useEffect, useState } from 'react';

const Timer = (props) => {
    const {
        cooldownTime,
        maxResendCount,
        onCountdownToZero,
        conditionToStartTimer,
        currentResendCount,
    } = props;

    const [resendCooldown, setResendCooldown] = useState(cooldownTime);
    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (resendCooldown === 0) {
            setResendCooldown(cooldownTime);
            onCountdownToZero();
        } else if (conditionToStartTimer && resendCooldown > 0) {
            const cooldown = setTimeout(() => {
                setResendCooldown(
                    (resendCooldownPrev) => resendCooldownPrev - 1
                );
            }, 1000);
            return () => clearTimeout(cooldown);
        }
    }, [
        conditionToStartTimer,
        cooldownTime,
        onCountdownToZero,
        resendCooldown,
    ]);

    if (!conditionToStartTimer) {
        return null;
    }

    if (currentResendCount < maxResendCount) {
        if (conditionToStartTimer && resendCooldown > 0) {
            return (
                <small className="color-blue">
                    Request a new one in{' '}
                    {`${resendCooldown} second${
                        resendCooldown % 60 > 1 ? 's' : ''
                    }`}
                </small>
            );
        }
    }

    return (
        <small className="color-blue">
            Request new code limit exceed {maxResendCount} times.
        </small>
    );
};

export default Timer;
